import * as XLSX from "xlsx";
import {saveWorkbook} from "../../../utils/excel";
import {SERVICE_CHECK_ITEMS, SERVICE_CHECK_ITEMS_MAPPING} from "../../../utils/constants";

const SHEET_NAMES = [
  { category: 'homeMedicalCare', name: '居家醫療' },
  { category: 'homeDentalCare', name: '到宅牙醫' },
  { category: 'homeNursingCare', name: '居家護理' },
  { category: 'mobilePharmacist', name: '行動藥師' },
  { category: 'mobileDietitian', name: '行動營養師' },
  { category: 'mobilePsychologist', name: '行動心理師' },
  { category: 'mobileRehabilitation', name: '行動復能' },
  { category: 'homeServices', name: '長照居家' },
]

const HEADER = ['申請人姓名', '個案符合服務申請之項目']
const WORKBOOK_FILE_NAME = '貼心到宅八大服務數據'

const getCheckedItems = (inputCase, categoryName) => {
  return SERVICE_CHECK_ITEMS[categoryName]
    .filter(item => inputCase[item])
    .map(item => SERVICE_CHECK_ITEMS_MAPPING[item])
};

export const useExportCases = ({
  data,
}) => {
  const exportData = () => {
    const workbook = XLSX.utils.book_new();

    for(const sheet of SHEET_NAMES) {
      const values = [HEADER];
      const cases = data.filter(d => d.category === sheet.category);
      for( const c of cases) {
        const checkedItems = getCheckedItems(c, sheet.category)
        values.push([
          c.patientName,
          checkedItems.join(','),
        ])
      }
      const workSheet = XLSX.utils.aoa_to_sheet(values);
      XLSX.utils.book_append_sheet(workbook, workSheet, sheet.name);
    }
    saveWorkbook({ workbook, fileName: WORKBOOK_FILE_NAME})
  }
  return { exportData }
}
